(function ($) {
  var $bodyHtml = $("body, html");

  (function initContactForm() {
    var $switcher = $(".form-contact-us .switcher-radio-group"),
      $switcherItems = $switcher.find("li"),
      $switcherLinks = $switcher.find("a"),
      $select = $(".form-contact-us .your-user-type select");

    $switcherLinks.on("click", function (e) {
      e.preventDefault();
      $switcherItems.removeClass("active");
      $(this).closest($switcherItems).addClass("active");
      $select.find("option").attr("selected", false);
      $select
        .find("option")
        .eq($(this).closest($switcherItems).index() + 1)
        .attr("selected", "selected");
    });

    $(".form-contact-us form").on("submit", function () {
      if (!$switcherItems.filter(".active").length) {
        $switcher.addClass("switcher-radio-group_error");
      } else {
        $switcher.removeClass("switcher-radio-group_error");
      }
    });
  })();

  (function initScrollUp() {
    var $document = $(document),
      $window = $(window),
      $btnScrollTop = $(".btn-scroll-top"),
      bottomBannerClass = "btn-scroll-top_banner",
      offsetClass = "btn-scroll-top_offset",
      pageHasBottomBanner = $(".js-bottom-banner").length,
      scrollTop = 200;

    if (pageHasBottomBanner) {
      $btnScrollTop.addClass(bottomBannerClass);
    }

    $btnScrollTop.on("click", function () {
      $bodyHtml.animate(
        {
          scrollTop: 0,
        },
        1200
      );
    });

    $window.on("scroll", function () {
      if (
        $window.scrollTop() >= scrollTop &&
        $btnScrollTop.hasClass("invisibe")
      ) {
        $btnScrollTop.addClass("fadeInUp").removeClass("fadeOutDown invisibe");
      } else if (
        $window.scrollTop() < scrollTop &&
        !$btnScrollTop.hasClass("invisibe")
      ) {
        $btnScrollTop.addClass("fadeOutDown invisibe").removeClass("fadeInUp");
      }
      // Offset button if bottom banner is present on the page
      if ($window.scrollTop() + $window.height() > $document.height() - 100) {
        $btnScrollTop.addClass(offsetClass);
      } else {
        $btnScrollTop.removeClass(offsetClass);
      }
    });
  })();

  (function inputFocus() {
    let $formFieldContainer = jQuery(".form-field"),
      $formField = $formFieldContainer.find(".formField-js");

    $formField.on("focusout", function () {
      let $currentField = jQuery(this);
      jQuery(this).parents(".form-field").removeClass("focus");
      if ($currentField.val().length > 0) {
        jQuery(this).parents(".form-field").addClass("not-empty");
      } else {
        jQuery(this).parents(".form-field").removeClass("not-empty");
      }
    });

    $formField.on("focus", function () {
      jQuery(this).parents(".form-field").addClass("focus");
    });

    $formField.each(function () {
      let $currentField = jQuery(this);
      if ($currentField.val().length > 0) {
        jQuery(this).parents(".form-field").addClass("not-empty");
        $currentField.on("change", function () {
          jQuery(this).parents(".form-field").addClass("not-empty");
        });
      }
    });
    let iwainterval = setInterval(function () {
      if (jQuery("input:-webkit-autofill")) {
        jQuery("input:-webkit-autofill").each(function () {
          jQuery(this).parents(".form-field").addClass("not-empty");
        });
      }
    }, 200);

    jQuery("select.form-control").on("select2:open", function (e) {
      jQuery(this).parents(".form-field").addClass("focus");
    });
    jQuery("select.form-control").on("select2:select", function (e) {
      jQuery(this)
        .parents(".form-field")
        .removeClass("focus")
        .addClass("not-empty");
    });
    jQuery(window).on("load", function () {
      clearInterval(iwainterval);
    });
  })();

  (function insertSiteUrlIntoForm() {
    $("[name=site-url]").each(function () {
      $(this).val(window.location.href);
    });
  })();
})(jQuery);
